<template>
  <div class="row page-titles">
    <div class="col-md-5 col-12 align-self-center">
      <h3 class="text-themecolor mb-0">{{ $route.meta.title_sub ? $route.meta.title_sub : $route.meta.title }}</h3>
    </div>
    <div class="col-md-7 col-12 align-self-center d-none d-md-flex justify-content-end">
      <ol class="breadcrumb mb-0 p-0 bg-transparent">
        <li class="breadcrumb-item" v-if="$route.meta.title_sub == ''">{{ $route.meta.title }}</li>
        <li class="breadcrumb-item" v-if="$route.meta.title_sub !== ''">
          <a href="javascript:void(0)">{{ $route.meta.title }}</a>
        </li>
        <li class="breadcrumb-item d-flex align-items-center" v-if="$route.meta.title_sub !== ''">{{ $route.meta.title_sub }}</li>
      </ol>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="ProfileModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="ProfileModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-fullscreen-md-down modal-xl modal-dialog-centered modal-dialog-scrollable">
        <ProfileModal :user="$store.state.user" />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileModal from './modal/profile_modal'

export default {
  components: {
    ProfileModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/breadcrumb_view.vue